import { render } from "./Scorecard.vue?vue&type=template&id=468ab5b7"
import script from "./Scorecard.vue?vue&type=script&setup=true&lang=js"
export * from "./Scorecard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Insights/Scorecard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "468ab5b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('468ab5b7', __exports__)) {
    api.reload('468ab5b7', __exports__)
  }
  
  module.hot.accept("./Scorecard.vue?vue&type=template&id=468ab5b7", () => {
    api.rerender('468ab5b7', render)
  })

}


export default __exports__